const insecableSpace = '\u00a0';

const replaceSpaceByNbsp = (str) => str.replace(/ ([;?!])/g, `${insecableSpace}$1`);

export default replaceSpaceByNbsp;
